import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import CameraViewPage, { getDefaultPageUI } from "components/pages/CameraViewPage";

export default function CaptureMabiDepositsCheckBack(props){
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "selectedCheckView" ], "back")
        .submit();

    return <CameraViewPage ui={ ui } className="capture-styles" />
}